import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { Modal } from "react-bootstrap";
import Button from "react-bootstrap-button-loader";
import { showError, showSuccess } from "ReduxErrorBar";
import { fetchPollAnalytics } from "PollAction";
import PollReslutUserListItem from "./poll-result-option-userlist";
import LocaleStrings from "Languages";

class ResultAnalytics extends Component {
  constructor(props) {
    super(props);
    this.state = { showModal: false, optionUsers: [] };
  }

  componentDidMount() {}

  openModal = () => {
    let { pollResult } = this.props;
    this.setState({ showModal: true });

    this.props.fetchPollAnalytics(
      this.props.session,
      pollResult,
      (response) => {
        if (response.success) {
          setTimeout(() => {
            this.renderUserList();
            this.setState({ optionUsers: response.result });
          }, 500);
        }
      }
    );
  };

  closeModal = () => {
    this.setState({ showModal: false });
  };

  renderUserList = () => {
    var { optionUsers } = this.state;
    var totalOptions = 2;

    if (optionUsers.length == 3) {
      totalOptions = 3;
    } else if (optionUsers.length == 4) {
      totalOptions = 4;
    }

    return _.map(optionUsers, (option, index) => {
      return (
        <PollReslutUserListItem
          key={`key_${index}`}
          option={option}
          totalOptions={totalOptions}
        />
      );
    });
  };

  render() {
    let { pollResult } = this.props;
    var iconUrl = `../../style/images/poll-icons/poll-analytics.png`;

    return (
      <div>
        <button
          type="button"
          className="btn i-custom-table-edit"
          onClick={() => this.openModal()}
        >
          <img className="i-custom-poll-result" src={iconUrl} />
        </button>
        <div>
          <Modal
            dialogClassName="poll-result-modal"
            className="modal-container"
            show={this.state.showModal === true ? true : false}
            onHide={this.closeModal}
            animation={true}
          >
            <Modal.Header>
              <div className="import-modal-title">
                {LocaleStrings.polls_qa_text_poll_result_analytics_title}
              </div>
              <button
                type="button"
                className="i-custom-cross-popup pull-right"
                onClick={() => this.closeModal()}
              >
                <img
                  className="i-custom-small"
                  src="../../style/images/custom-icons/cross-black.png"
                />
              </button>
            </Modal.Header>
            <Modal.Body>
              {/* <div className="import-header">
                                <div className="import-modal-title">{LocaleStrings.polls_qa_text_poll_result_analytics_title}</div>
                                <button type="button" className="close btn-sm btn-close " onClick={() => this.closeModal()} style={{marginTop:-25}}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div> */}

              <div className="poll-result-question">{pollResult.question}</div>

              <div className="row" style={{ minHeight: 550 }}>
                {this.renderUserList()}
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button
                className="btn btn-custom-white"
                onClick={this.closeModal}
              >
                {LocaleStrings.button_close}
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
  };
}

export default connect(mapStateToProps, {
  fetchPollAnalytics,
  showError,
  showSuccess,
})(ResultAnalytics);
